<div
  class="editable"
  *ngIf="!editing"
  (click)="edit()"
  (focus)="edit()"
  tabindex="0"
  [ngClass]="{ readonly: readonly }"
  [matTooltip]="showTip"
  [class.locked]="fieldDef.locked"
>
  {{ value }}
</div>
<div *ngIf="editing">
  <input
    #inputEditorControl
    matInput
    [formControl]="formCtrl"
    (keyup.enter)="onBlur($event)"
    (blur)="onBlur($event)"
    [matAutocomplete]="matAutocomplete"
    [spellcheck]="false"
    [disabled]="isDisabled"
  />

  <mat-autocomplete
    #matAutocomplete="matAutocomplete"
    [disableRipple]="true"
    (optionSelected)="autoCompleteSelected($event)"
    (closed)="autoCompleteClosed()"
  >
    <mat-option class="no-results" *ngIf="searchResults && !searchResults.length"> No results! </mat-option>

    <mat-option *ngFor="let result of searchResults" [value]="result">
      {{ result }}
    </mat-option>
  </mat-autocomplete>
</div>
